import React, { useState } from 'react';
import { useRouter } from 'next/router'; 
import styles from './StartSection.module.css'; 
import sendJoinConfirmation from 'evcharging/app/client/sendJoinConfirmation'; 
import Loader from 'evcharging/components/Loader';
import headerimage1 from 'assets/lp/headerimage1.png';

const StartSection = () => {
  const router = useRouter(); 
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [acceptance, setAcceptance] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  // Funcția de validare
  const validateForm = () => {
    if (!name || !email) {
      setError('Please fill in all required fields (Name and Email).');
      return false;
    }
    // Validarea simplă a email-ului
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      return false;
    }
    return true;
  };

  // Funcția de submit
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); // Resetează eroarea anterioară

    if (!validateForm()) return; // Dacă formularul nu este valid, nu continua

    setIsLoading(true); // Setează stare de încărcare

    const values = {
      name,
      company,
      phone,
      email,
      agreeToReceive: acceptance ? 'yes' : 'no',
    };

    try {
      await sendJoinConfirmation(values);
      setSuccess(true); 
      router.push('/evcharging/thankyou'); 
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false); 
    }
  };

  return (
    <section className={styles.start} id="start">
      <div className={styles.overlaystart} style={{
    backgroundImage: `linear-gradient(270deg, #131c21, rgba(19, 28, 33, 0.5) 50%, #131c21 85.67%), url(${headerimage1})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}>
        <div className={styles.left}>
          <h1 className={styles.heading1}>Start charging today with Energy5 turnkey solutions</h1>
          <p className={styles.large}>
            Turn your location into a charging destination with our all-in-one universal solution designed for all electric and hybrid vehicle manufacturers
          </p>
        </div>

        <div className={styles.right}>
          <p className={styles.title}>Let's talk</p>
          <p className={styles.smalltext}>
            Fill in the contact form, and we will get back to you shortly with all the details on how Energy5 can integrate the EV Charging infrastructure into your business!
          </p>

          {success ? (
            <div className={styles.success}> </div>
          ) : (
            <form className={styles.headerform} onSubmit={handleSubmit}>
              {error && <div className={styles.error}>{error}</div>} {/* Mesaj de eroare */}
              
              <input
                className={styles.formtext}
                type="text"
                id="name"
                name="name"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              
              <input
                className={styles.formtext}
                type="text"
                id="company"
                name="company"
                placeholder="Company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              />
              
              <input
                className={styles.formtext}
                type="text"
                id="phone"
                name="phone"
                placeholder="Phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              
              <input
                className={styles.formtext}
                type="email"
                id="email"
                name="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              
              <div className={styles.checkboxWrapper}>
                <input
                  className={styles.formcheckbox}
                  type="checkbox"
                  id="acceptance"
                  name="acceptance"
                  checked={acceptance}
                  onChange={(e) => setAcceptance(e.target.checked)}
                />
                <label className={styles.formlabel} htmlFor="acceptance">
                  By submitting this form you agree to receive text messages.
                  <br />Your information will not be shared with any third party.
                </label>
              </div>
              
              <input
                className={styles.formsubmit}
                type="submit"
                value={isLoading ? 'Sending...' : 'Request a callback'}
                disabled={isLoading} // Dezactivează butonul când se încarcă
              />
              {isLoading && <Loader />} {/* Afișează Loader dacă se trimite */}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default StartSection;
